export default __webpack_public_path__ + "media/images/images/raty/cancel-off-fce1447214c4de9ff918016164e9512e.png";